module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-pound-b10a0529.svg";